import React, { useEffect, useState } from "react";
import Modal from "../../../modal/modal";
import Select from "../../../select/select";
import Button from "../../../button/button";
import InputDate from "../../../inputDate/inputDate";
import './addPromotionToGroup.scss'
import { PostAddPromotionToGroup } from "../../../../utils/Apis/principalApis";

const AddPromotionToGroup = ({ onClose, open, showAlert, idGroup, fetchTeacherClassData }) => {
    const [conceptSelected, setConceptSelected] = useState('4');
    const [typeSelected, setTypeSelected] = useState('');
    const [percentageValue, setPercentageValue] = useState('');
    const [dateBegin, setDateBegin] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const [disabledButton, setDisabledButton] = useState(false);

    // 📘 Conceptos disponibles
    const concepts = [
        { value: '4', label: 'Inscripción' },
        { value: '1', label: 'Colegiatura' },
        { value: 'BF', label: 'Buen Fin' } // 👈 Solo indicador, no se envía a BD
    ];
    // 📘 Tipos normales
    const defaultTypes = [
        { value: '1', label: 'Gratis' },
        { value: '2', label: 'Porcentaje' },
        { value: '3', label: '2x1' },
    ];

    // 📘 Tipos especiales cuando se selecciona Buen Fin
    const buenFinTypes = [
        { value: '4', label: 'Presencial' }, // Se enviará como type_promotion = 4
        { value: '5', label: 'Online' }      // Se enviará como type_promotion = 5
    ];

    // 📘 Porcentajes
    const percentages = [
        { value: '25', label: '25%' },
        { value: '50', label: '50%' },
        { value: '75', label: '75%' },
    ];

    const handleTypeChange = (value) => {
        if (value !== '2') {
            setPercentageValue('');
        }
        setTypeSelected(value);
    };

    useEffect(() => {
        if (open) {
            setDateBegin('');
            setDateEnd('');
            setTypeSelected('');
            setPercentageValue('');
        }
    }, [open]);
    useEffect(() => {
        setDateBegin('');
        setDateEnd('');
        setTypeSelected('');
        setPercentageValue('');
    }, [conceptSelected])

    const savePromotionToGroup = async () => {
        setDisabledButton(true);

        const isMissingConceptOrType = !conceptSelected || !typeSelected;
        const isMissingPercentage = typeSelected === '2' && !percentageValue;

        if (isMissingConceptOrType || isMissingPercentage) {
            showAlert('info', 'Por favor verifica que todos los campos estén llenos');
            setDisabledButton(false);
            return;
        }

        if (!dateBegin || !dateEnd) {
            showAlert('info', 'Selecciona las fechas');
            setDisabledButton(false);
            return;
        }

        if (dateEnd < dateBegin) {
            showAlert('info', 'Verifique que la fecha de finalización sea mayor a la fecha inicial');
            setDisabledButton(false);
            return;
        }

        const isBuenFin = conceptSelected === 'BF';
        const conceptToSend = isBuenFin ? '4' : conceptSelected; // Buen Fin aplica a inscripción

        const promotioToGroup = await PostAddPromotionToGroup(
            idGroup,
            conceptToSend,
            typeSelected,
            percentageValue,
            dateBegin,
            dateEnd
        );

        if (promotioToGroup.status === 200) {
            showAlert('success', promotioToGroup.message);
            fetchTeacherClassData(true);
            setTimeout(() => {
                onClose();
                setDisabledButton(false);
            }, 3500);
        } else {
            showAlert('danger', promotioToGroup.message);
            setDisabledButton(false);
        }
    };


    // 🔍 Determina qué lista de tipos mostrar
    const typeOptions = conceptSelected === 'BF' ? buenFinTypes : defaultTypes;

    // 👀 Ocultar porcentaje si el concepto es Buen Fin o el tipo no es “Porcentaje”
    const showPercentage =
        conceptSelected !== 'BFIN' && typeSelected === '2';

    return (
        <Modal onClose={onClose} isOpen={open} overlayClick={false}>
            <div className="add-promotion-to-group-modal">
                <h1 className="title-1">Agregar promoción a grupo</h1>

                <Select
                    options={concepts}
                    placeholder={'Concepto'}
                    className={'main-color'}
                    value={conceptSelected}
                    onChange={(e) => setConceptSelected(e.target.value)}
                />

                <Select
                    options={typeOptions}
                    placeholder={'Tipo'}
                    className={'main-color'}
                    value={typeSelected}
                    onChange={(e) => handleTypeChange(e.target.value)}
                />

                {showPercentage && (
                    <Select
                        options={percentages}
                        placeholder={'Selecciona el porcentaje'}
                        className={'main-color'}
                        value={percentageValue}
                        onChange={(e) => setPercentageValue(e.target.value)}
                    />
                )}

                <div className="add-promotion-to-group-modal-container-dates">
                    <InputDate
                        selectionType={'date'}
                        onChange={(date) => setDateBegin(date)}
                        placeholder={"Selecciona fecha de inicio"}
                    />
                    <InputDate
                        selectionType={'date'}
                        onChange={(date) => setDateEnd(date)}
                        placeholder={"Selecciona fecha de finalización"}
                    />
                </div>

                <div className="confirm-buttons-section">
                    <Button
                        text="Cancelar"
                        backgroundColor="red"
                        onClick={onClose}
                        disabled={disabledButton}
                    />
                    <Button
                        text="Guardar"
                        onClick={savePromotionToGroup}
                        disabled={disabledButton}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default AddPromotionToGroup;
